<template>
  <div class="bi-emitter-summary-section">
    <div class="__grid">
      <BIDisplayValue
        v-for="kpi in kpis"
        :key="kpi.key"
        size="medium"
        :title="kpi.title"
        :value="valueOf('current_period', kpi.key)"
        :comparisonValue="valueOf('previous_period', kpi.key)"
        :type="kpi.type"
        :show-comparison-value="kpi.type === 'number'"
        :show-comparison-value-in-tooltip="kpi.type !== 'number'"
        :previousPeriodFrom="data && data.previous_period.start_date"
        :previousPeriodTo="data && data.previous_period.end_date"
      />
    </div>

    <BaseRoundButton
      v-if="allowEdit && !pending"
      class="edit-button"
      icon="edit-2"
      :size="30"
      :disabled="pending"
      @click.native="$emit('on-edit-clicked')"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import BIDisplayValue from './BIDisplayValue.vue';
import BaseRoundButton from '@/components/base/BaseRoundButton.vue';

// Same KPIs as the performance summary (BISummarySection), with the same labels, minus
// the success rate and the cumulative won value, plus the number of tenders published.
// There is no bid ratio for an emitter: the API has no potential bids per emitter.
const SUMMARY = 'page.business-intelligence.summary';
export const EMITTER_KPIS = [
  { key: 'tenders_published', label: 'page.business-intelligence.emitter.summary.tenders-published', type: 'number' },
  { key: 'bids_placed', label: `${SUMMARY}.success-rate.bids-submitted`, type: 'number' },
  { key: 'tenders_won', label: `${SUMMARY}.success-rate.bids-won`, type: 'number' },
  { key: 'lowest', label: `${SUMMARY}.won-bids.min`, type: 'currency' },
  { key: 'median', label: `${SUMMARY}.won-bids.median`, type: 'currency' },
  { key: 'highest', label: `${SUMMARY}.won-bids.max`, type: 'currency' },
];

export default {
  name: 'BIEmitterSummarySection',
  components: {
    BIDisplayValue,
    BaseRoundButton,
  },
  props: {
    // `{ current_period, previous_period }` of aloha.bi's emitter summary; undefined while loading
    data: {
      type: Object,
    },
    allowEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters('biDashboard', ['pending']),
    kpis() {
      return EMITTER_KPIS.map((kpi) => ({
        ...kpi,
        title: this.$t(kpi.label),
      }));
    },
  },
  methods: {
    // undefined keeps the skeleton; null (no award in the period) displays as "-"
    valueOf(period, key) {
      if (!this.data || !this.data[period] || this.data[period][key] === undefined) {
        return undefined;
      }
      return this.data[period][key];
    },
  },
};
</script>

<style lang="scss">
.bi-emitter-summary-section {
  position: relative;

  .edit-button {
    position: absolute;
    top: -10px;
    right: -10px;
  }

  .__grid {
    display: grid;
    // Never wider than its box, a phone's included.
    grid-template-columns: repeat(auto-fit, minmax(min(180px, 100%), 1fr));
    gap: 12px;
    align-items: start;
  }
}
</style>
